import AdminHeader from "../components/header/AdminHeader";
import FooterSmall from "../components/footer/FooterSmall";

import { Outlet } from "react-router-dom";
import AdminDashPage from "./adminDashPage";
import { AdminProvider } from "../context/Admins/AdminContext";

export default function AdminLayout() {
    return (
        <AdminProvider>
            <AdminHeader />
            <AdminDashPage>
                <main style={{ minHeight: "calc(100vh - 145px)" }}>
                    <Outlet />
                </main>
            </AdminDashPage>
            <FooterSmall />
        </AdminProvider>
    );
}